import React from "react";

const Asana = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.04 19.059c-3.843 0-6.959 2.996-6.959 6.693 0 3.696 3.116 6.692 6.96 6.692 3.843 0 6.959-2.996 6.959-6.692 0-3.697-3.116-6.693-6.96-6.693Zm-18.08 0C5.115 19.06 2 22.055 2 25.752c0 3.696 3.116 6.692 6.96 6.692 3.843 0 6.96-2.996 6.96-6.692 0-3.697-3.117-6.693-6.96-6.693Zm16-8.366c0 3.696-3.117 6.693-6.96 6.693-3.844 0-6.96-2.997-6.96-6.693C11.04 6.997 14.157 4 18 4c3.843 0 6.96 2.997 6.96 6.693Z"
            fill="#F06A6A"
        />
    </svg>
);

export default Asana;
